module.exports = __webpack_public_path__ + "static/img/logo.7cc7a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 305
// module chunks = 1